export default {
  page: {
    title: 'Separador de palabras',
    subtitle: 'Herramientas',
  },
  card: {
    title: 'Separador de palabras',
  },
  form: {
    text: {
      label: 'Pegue el texto aquí',
      placeholder: '',
    },
    minWordLength: {
      label: 'Tamaño mínimo',
      tooltip:
        'Las palabras con cantidad de letras menor que este valor serán ignoradas y no se contabilizarán en el resultado.',
    },
    variations: {
      label: 'Generar varios:',
    },
    result: {
      label: 'Texto generado',
      placeholder: 'El texto generado aparecerá aquí',
    },
    repeatedWords: {
      label: 'Palabras repetidas:',
    },
    totalWords: {
      label: 'Total de palabras:',
    },
  },
  table: {
    group: 'Grupo',
    repeatedWords: 'Palabras repetidas',
    totalWords: 'Total de palabras',
    noContent: 'Todavía no hay ningún texto generado.',
  },
  alert: {
    repeatedWord: '¡Palabra repetida!',
  },
};
